import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  boxApply1qmzdb3dh90hg as boxApply,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../js/coreRuntime.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../exceptions.mjs';
import { AbstractCollection1g9uvtcheckwb as AbstractCollection } from './AbstractCollection.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../Unit.mjs';
import { KtList3hktaavzmj137 as KtList } from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SubListClass;
function SubList() {
  if (SubListClass === VOID) {
    class $ extends AbstractList() {
      static aj(list, fromIndex, toIndex) {
        var $this = this.bj();
        $this.xi_1 = list;
        $this.yi_1 = fromIndex;
        $this.zi_1 = 0;
        Companion_instance.k6($this.yi_1, toIndex, $this.xi_1.v2());
        $this.zi_1 = toIndex - $this.yi_1 | 0;
        return $this;
      }
      w2(index) {
        Companion_instance.n7(index, this.zi_1);
        return this.xi_1.w2(this.yi_1 + index | 0);
      }
      v2() {
        return this.zi_1;
      }
      g3(fromIndex, toIndex) {
        Companion_instance.k6(fromIndex, toIndex, this.zi_1);
        return SubList().aj(this.xi_1, this.yi_1 + fromIndex | 0, this.yi_1 + toIndex | 0);
      }
    }
    initMetadataForClass($, 'SubList', VOID, VOID, [AbstractList(), RandomAccess()]);
    SubListClass = $;
  }
  return SubListClass;
}
var IteratorImplClass;
function IteratorImpl() {
  if (IteratorImplClass === VOID) {
    class $ {
      constructor($outer, $box) {
        boxApply(this, $box);
        this.dj_1 = $outer;
        this.cj_1 = 0;
      }
      v1() {
        return this.cj_1 < this.dj_1.v2();
      }
      w1() {
        if (!this.v1())
          throw NoSuchElementException().y6();
        var _unary__edvuaz = this.cj_1;
        this.cj_1 = _unary__edvuaz + 1 | 0;
        return this.dj_1.w2(_unary__edvuaz);
      }
    }
    initMetadataForClass($, 'IteratorImpl');
    IteratorImplClass = $;
  }
  return IteratorImplClass;
}
var ListIteratorImplClass;
function ListIteratorImpl() {
  if (ListIteratorImplClass === VOID) {
    class $ extends IteratorImpl() {
      constructor($outer, index, $box) {
        if ($box === VOID)
          $box = {};
        $box.gj_1 = $outer;
        super($outer, $box);
        Companion_instance.e7(index, this.gj_1.v2());
        this.cj_1 = index;
      }
      f7() {
        return this.cj_1 > 0;
      }
      g7() {
        if (!this.f7())
          throw NoSuchElementException().y6();
        this.cj_1 = this.cj_1 - 1 | 0;
        return this.gj_1.w2(this.cj_1);
      }
    }
    initMetadataForClass($, 'ListIteratorImpl');
    ListIteratorImplClass = $;
  }
  return ListIteratorImplClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.j6_1 = 2147483639;
      }
      n7(index, size) {
        if (index < 0 || index >= size) {
          throw IndexOutOfBoundsException().n3('index: ' + index + ', size: ' + size);
        }
      }
      e7(index, size) {
        if (index < 0 || index > size) {
          throw IndexOutOfBoundsException().n3('index: ' + index + ', size: ' + size);
        }
      }
      k6(fromIndex, toIndex, size) {
        if (fromIndex < 0 || toIndex > size) {
          throw IndexOutOfBoundsException().n3('fromIndex: ' + fromIndex + ', toIndex: ' + toIndex + ', size: ' + size);
        }
        if (fromIndex > toIndex) {
          throw IllegalArgumentException().s2('fromIndex: ' + fromIndex + ' > toIndex: ' + toIndex);
        }
      }
      eh(startIndex, endIndex, size) {
        if (startIndex < 0 || endIndex > size) {
          throw IndexOutOfBoundsException().n3('startIndex: ' + startIndex + ', endIndex: ' + endIndex + ', size: ' + size);
        }
        if (startIndex > endIndex) {
          throw IllegalArgumentException().s2('startIndex: ' + startIndex + ' > endIndex: ' + endIndex);
        }
      }
      xa(oldCapacity, minCapacity) {
        var newCapacity = oldCapacity + (oldCapacity >> 1) | 0;
        if ((newCapacity - minCapacity | 0) < 0)
          newCapacity = minCapacity;
        if ((newCapacity - 2147483639 | 0) > 0)
          newCapacity = minCapacity > 2147483639 ? 2147483647 : 2147483639;
        return newCapacity;
      }
      q7(c) {
        var hashCode_0 = 1;
        var _iterator__ex2g4s = c.u1();
        while (_iterator__ex2g4s.v1()) {
          var e = _iterator__ex2g4s.w1();
          var tmp = imul(31, hashCode_0);
          var tmp1_elvis_lhs = e == null ? null : hashCode(e);
          hashCode_0 = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
        }
        return hashCode_0;
      }
      p7(c, other) {
        if (!(c.v2() === other.v2()))
          return false;
        var otherIterator = other.u1();
        var _iterator__ex2g4s = c.u1();
        while (_iterator__ex2g4s.v1()) {
          var elem = _iterator__ex2g4s.w1();
          var elemOther = otherIterator.w1();
          if (!equals(elem, elemOther)) {
            return false;
          }
        }
        return true;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var AbstractListClass;
function AbstractList() {
  if (AbstractListClass === VOID) {
    class $ extends AbstractCollection() {
      static bj() {
        return this.s6();
      }
      u1() {
        return new (IteratorImpl())(this);
      }
      w4(element) {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.indexOfFirst' call
          var index = 0;
          var _iterator__ex2g4s = this.u1();
          while (_iterator__ex2g4s.v1()) {
            var item = _iterator__ex2g4s.w1();
            if (equals(item, element)) {
              tmp$ret$1 = index;
              break $l$block;
            }
            index = index + 1 | 0;
          }
          tmp$ret$1 = -1;
        }
        return tmp$ret$1;
      }
      a3(index) {
        return new (ListIteratorImpl())(this, index);
      }
      g3(fromIndex, toIndex) {
        return SubList().aj(this, fromIndex, toIndex);
      }
      equals(other) {
        if (other === this)
          return true;
        if (!(!(other == null) ? isInterface(other, KtList()) : false))
          return false;
        return Companion_instance.p7(this, other);
      }
      hashCode() {
        return Companion_instance.q7(this);
      }
    }
    initMetadataForClass($, 'AbstractList', VOID, VOID, [AbstractCollection(), KtList()]);
    AbstractListClass = $;
  }
  return AbstractListClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance1a0yry1hi33tg,
  AbstractList as AbstractList3ck35puwbp1e9,
};
//endregion

//# sourceMappingURL=AbstractList.mjs.map
